import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {isInViewportMixin} from '@aofl/component-utils';
import {isMobile} from '@aoflmkt/is-mobile';
import {clickTrackerMixin} from '../../../../modules/click-tracker-mixin';
import {environment} from '../../../../modules/constants-enumerate';

const Mixin = isInViewportMixin(clickTrackerMixin(AoflElement));

/**
 * @summary DownloadHeader
 * @class DownloadHeader
 * @extends {AoflElement}
 */
@customElement('download-header')
class DownloadHeader extends Mixin {
  /**
   * Creates an instance of DownloadHeader.
   */
  constructor() {
    super();
  }

  /**
   * @readonly
   */
  static is = 'download-header';

  /**
   * @return {Object}
   */
  @property({type: Boolean, attribute: 'prevent-redirect'})
  preventRedirect = false;
  @property({type: Boolean, attribute: 'hide-back-button'})
  hideBackButton = false;

  /**
   *
   */
  connectedCallback() {
    super.connectedCallback();
    this.displayBackButton = (isMobile.apple.device && environment.IN_APP && !this.hideBackButton);
    this.displayCloseAppButton = (environment.IN_APP && environment.IS_DESKTOP);
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render(template, [styles]);
  }
}

export default DownloadHeader;
